export default "__VITE_ASSET__nXBgXu$R__"